import { render, staticRenderFns } from "./SeStdTaxForm1120.vue?vue&type=template&id=daef1484"
import script from "./SeStdTaxForm1120.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm1120.vue?vue&type=script&lang=js"
import style0 from "./SeStdTaxForm1120.vue?vue&type=style&index=0&id=daef1484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports